export const VISIBLE_TIME = 8000;
export const FALLBACK_AGE = '18+';
